import React, { useState } from "react";
import "../components/css/Nav.css";
import { NavList } from "./constants/index";
import { HeaderBottomList } from "./constants/index";

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="container-fluid">
      <nav className="navbar navbar-expand-lg bg-white border-bottom">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <button
              className="navbar-toggler"
              type="button"
              onClick={toggleSidebar}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          {/* <div className="d-flex d-lg-none align-items-center ms-auto">
            <a href="#" className="me-2">
              <i className="bi bi-facebook fs-3 text-war"></i>
            </a>
            <a href="#" className="me-2">
              <i className="bi bi-instagram fs-3 text-war"></i>
            </a>
            <a href="#" className="me-2">
              <i className="bi bi-whatsapp fs-3 text-war"></i>
            </a>
            <a href="#">
              <i className="bi bi-browser-chrome fs-3 text-war"></i>
            </a>
          </div> */}

          {isSidebarOpen && (
            <div
              className={`mobile-sidebar ${
                isSidebarOpen ? "sidebar-open" : ""
              }`}
            >
              <button
                className="sidebar-close"
                onClick={toggleSidebar}
                aria-label="Close"
              >
                ×
              </button>

              <ul className="navbar-nav px-3">
                {NavList.map((item, index) => (
                  <li className="nav-item" key={index}>
                    <a
                      className="nav-link"
                      href={item.path}
                      onClick={toggleSidebar}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>

              <div className="header-bottom-links px-3 mt-4">
                {HeaderBottomList.map((item, index) => (
                  <a 
                    key={item.label}
                    href={item.path}
                    className={`text-dark text-decoration-none d-block py-2 fw-semibold ${
                      index !== HeaderBottomList.length - 1
                        ? "border-bottom"
                        : ""
                    }`}
                    style={
                      index !== HeaderBottomList.length - 1
                        ? {
                            borderBottom: "2px solid rgba(0, 0, 0, 0.3)",
                          }
                        : {} 
                    }
                  >
                    {item.label}
                  </a>
                ))}
                <div className="mt-4 p-2">
                  <a
                    href="/contact"
                    className="btn text-white  quote-btn w-100 fw-semibold "
                    onClick={toggleSidebar}
                  >
                    Get Your Estimation
                  </a>
                </div>
              </div>
            </div>
          )}

          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-none d-lg-flex flex-row">
              {NavList.map((item, index, arr) => (
                <li className="nav-item" key={item} data-sal='slide-right' data-sal-duration="2000" data-sal-delay="300">
                  <a
                    className={`nav-link fw-semibold px-3  ${
                      index !== arr.length - 1 ? "border-end" : ""
                    }`}
                    href={item.path}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>

            {/* <div className="d-none d-lg-flex align-items-center social-icons">
              <a href="#" className="me-3">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#" className="me-3">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#" className="me-3">
                <i className="bi bi-whatsapp"></i>
              </a>
              <a href="#">
                <i className="bi bi-browser-chrome"></i>
              </a>
            </div> */}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
